// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3AYhi","rootSmall":"AddTileButton_rootSmall__2Ydir"};